import { render } from "./AppSidebar2.vue?vue&type=template&id=200acd2a"
import script from "./AppSidebar2.vue?vue&type=script&lang=js"
export * from "./AppSidebar2.vue?vue&type=script&lang=js"

import "./AppSidebar2.vue?vue&type=style&index=0&id=200acd2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__